import React from 'react';
import Button from "../Button";
import Icon from "../Icon";

interface IOffcanvasBackButtonProps {
    label: string;
}
const OffcanvasBackButton: React.FC<IOffcanvasBackButtonProps> = ({
    label,
}) => {
    return <Button
        className="offcanvas-back"
        onClick={() => {
            const activeDropdown = document.querySelector(
                '.offcanvas-body .dropdown-toggle.show',
            );
            activeDropdown &&
            (activeDropdown as HTMLButtonElement).click();
        }}
    >
        <Icon name="chevron-thin-left" />
        {label}
    </Button>;

}

export default OffcanvasBackButton;